import { ComponentErrorBoundaryState } from 'common-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorProcessPage from '../ErrorProcessPage/ErrorProcessPage';

export interface FundBigChartErrorProps {
  errorState: ComponentErrorBoundaryState;
  clearState: () => void;
}

const FundBigChartError: React.FC<FundBigChartErrorProps> = ({ errorState }) => {
  const [t] = useTranslation('error');

  return (
      <ErrorProcessPage errorCode={errorState.errorCode ?? 'FM.FBCE.UNKW'}
                        onClick={() => {}}
                        customTitle={t('chart-error-title')}
                        customText={t('chart-error-text')}
                        hideButtons
      />
  );
};

export default FundBigChartError;